import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="backup-codes"
export default class extends Controller {
  static targets = ["codesData", "downloadButton", "copyButton", "printButton"]

  connect() {
    this.codes = this.codesDataTarget.textContent.trim().split('\n')
  }

  async copyAll() {
    try {
      await navigator.clipboard.writeText(this.codes.join('\n'))
      this.showFeedback(this.copyButtonTarget, 'Copied!', 'success')
    } catch (error) {
      this.showFeedback(this.copyButtonTarget, 'Copy failed', 'error')
    }
  }

  downloadPdf() {
    // Create a simple text file for now - PDF generation would require additional libraries
    const content = `CEIR Multi-Factor Authentication Backup Codes\n\nGenerated: ${new Date().toLocaleDateString()}\n\nIMPORTANT: Each code can only be used once. Store these safely.\n\nBackup Codes:\n${this.codes.map((code, index) => `${index + 1}. ${code}`).join('\n')}\n\nKeep these codes in a secure location separate from your device.`
    
    const blob = new Blob([content], { type: 'text/plain' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `ceir-backup-codes-${new Date().toISOString().split('T')[0]}.txt`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
    
    this.showFeedback(this.downloadButtonTarget, 'Downloaded!', 'success')
  }

  print() {
    const printContent = `
      <html>
        <head>
          <title>CEIR MFA Backup Codes</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            .header { text-align: center; margin-bottom: 30px; }
            .warning { background: #fff3cd; border: 1px solid #ffeaa7; padding: 15px; margin: 20px 0; border-radius: 5px; }
            .codes { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin: 20px 0; }
            .code { border: 2px dashed #ccc; padding: 10px; text-align: center; font-family: monospace; font-size: 14px; }
            .footer { margin-top: 30px; font-size: 12px; color: #666; }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>CEIR Multi-Factor Authentication</h1>
            <h2>Backup Codes</h2>
            <p>Generated: ${new Date().toLocaleDateString()}</p>
          </div>
          
          <div class="warning">
            <strong>IMPORTANT:</strong> Each code can only be used once. Store these codes in a secure location separate from your device. You can use them to access your account if you lose your authenticator device.
          </div>
          
          <div class="codes">
            ${this.codes.map(code => `<div class="code">${code}</div>`).join('')}
          </div>
          
          <div class="footer">
            <p>Keep these codes secure and do not share them with anyone.</p>
            <p>If you suspect these codes have been compromised, generate new ones immediately.</p>
          </div>
        </body>
      </html>
    `
    
    const printWindow = window.open('', '_blank')
    printWindow.document.write(printContent)
    printWindow.document.close()
    printWindow.focus()
    printWindow.print()
    printWindow.close()
    
    this.showFeedback(this.printButtonTarget, 'Printing...', 'success')
  }

  showFeedback(button, message, type) {
    const originalText = button.innerHTML
    const colorClass = type === 'success' ? 'bg-green-600' : 'bg-red-600'
    
    button.innerHTML = message
    button.classList.remove('bg-blue-600', 'bg-gray-600', 'bg-green-600', 'hover:bg-blue-700', 'hover:bg-gray-700', 'hover:bg-green-700')
    button.classList.add(colorClass)
    button.disabled = true
    
    setTimeout(() => {
      button.innerHTML = originalText
      button.classList.remove(colorClass)
      button.classList.add('bg-blue-600', 'hover:bg-blue-700')
      button.disabled = false
    }, 2000)
  }
}
